import type { AlternativePath } from "@/types/menu";

export const testIsCurrentUrl = (
  subMenuPath: string,
  path: string,
  alternativePaths?: Array<AlternativePath>
): boolean | string => {
  const regex = new RegExp(`^${subMenuPath}(|/(\\d+(|/[^/]+)?))?$`);
  if (regex.test(path)) return true;
  else if (alternativePaths) {
    const alternativePath = alternativePaths.find((altPath) =>
      new RegExp(`^${altPath.regex}$`).test(path)
    );
    return alternativePath?.label ?? false;
  }
  return false;
};
